import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  OWN_ONLY_TABS,
  TAB_LABELS,
  type ProfileTab,
  PROFILE_TABS,
} from './profile-tabs';

export type ProfileTabsProps = {
  tab: ProfileTab;
  isOwnProfile: boolean;
  displayName: string;
};

export default function ProfileTabs({
  tab,
  isOwnProfile,
  displayName,
}: ProfileTabsProps) {
  const tabs = PROFILE_TABS.filter(
    (t) => isOwnProfile || !OWN_ONLY_TABS.includes(t)
  );
  const activeRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [tab]);

  return (
    <nav
      aria-label="Profile sections"
      className="sticky top-0 z-30 flex gap-1 overflow-x-auto border-b border-bk-gold-dim/40 bg-bk-bg-mid/95 px-2 backdrop-blur-md sm:px-4"
    >
      {tabs.map((t) => {
        const active = t === tab;
        return (
          <Link
            key={t}
            ref={active ? activeRef : undefined}
            to={`/user/${displayName}?tab=${t}`}
            className={[
              'shrink-0 border-b-2 px-3 py-3 text-xs font-bold uppercase tracking-wider transition-colors sm:px-4 sm:text-sm',
              active
                ? 'border-bk-gold text-bk-gold-bright'
                : 'border-transparent text-bk-muted hover:text-bk-gold',
            ].join(' ')}
            aria-current={active ? 'page' : undefined}
          >
            {TAB_LABELS[t]}
          </Link>
        );
      })}
    </nav>
  );
}
